import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=4c4f9c68&scoped=true&"
import script from "./Accessibility.vue?vue&type=script&lang=js&"
export * from "./Accessibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4f9c68",
  null
  
)

export default component.exports